import m from 'mithril';
import './app_style.scss';
import { InitialConfigurationData as InitialConfigurationData, CustomerSupportInfo} from './Models';
import { AppComponents , setupAppComponents} from './app_common_setup';
import BookingSearchFormState from './states/BookingSearchFormState';
import { Fsm } from 'little-fsm';
import { appRootDesktopFsmBuilder, DesktopManifiest, FindBookingContext } from './states/app_desktop_root';
import { buildFindBookingPresenter } from './presenters/desktop/FindBookingPresenter';

declare global {
    interface Window {
        globalLanguageConfig: any;
    }
}

setupAppComponents("app", (appComponents:AppComponents) => {
    let dataSource = appComponents.dataSource;
    dataSource.authentication(Number(appComponents.branding.agentId), appComponents.branding.channel, "").then(result => {
        if(result.accessToken != null){
            dataSource.fetchInitialConfigurationData(result).then(initialConfigData => {
                initAppUI(appComponents, initialConfigData, Number(appComponents.branding.agentId), appComponents.customerSupport);
            });
        }
    })
});

function initAppUI(appComponents:AppComponents, initialConfigData:InitialConfigurationData, agentId: number, customerSupportInfo: CustomerSupportInfo) {
    let fsm:Fsm<DesktopManifiest> = appRootDesktopFsmBuilder();
    handleRoutingWithHistoryAPI(fsm);

    fsm.init('find_booking', new FindBookingContext(new BookingSearchFormState(), null))

    let findBookingPresenter = buildFindBookingPresenter(fsm.subFsm('find_booking'), appComponents, initialConfigData);        

    m.mount(appComponents.rootElement, {
        view: function() {
            let currState = fsm.getCurrentState();

            if(currState == 'find_booking'){
                return findBookingPresenter.render();
            } else {
                return m("div", `No screen for the given state ${currState}`);
            }
        }
    });
}

function handleRoutingWithHistoryAPI(fsm:Fsm<any>) {
    fsm.setStateChangeEffect((oldState, newState, eventName) => {
        console.info(`State changed from ${oldState?.key} to ${newState?.key}`);

        if(eventName != 'back') {
            if(oldState) {            
                window.history.pushState(newState, "", `?state=${newState.key}`);
                console.log(`Pushed state ${newState.key}`)
            } else {    
                window.history.pushState(newState, "", `?state=${newState.key}`)
                console.log(`Replaced state with ${newState.key}`)
            } 
        } else {
            console.log(`Did not push state ${newState.key} to history since back is not allowed`)
        }               
    });

    window.addEventListener('popstate', (event) => {
        console.debug("handling pop state event: ", event);
        console.debug("location.href: ", location.href);
        console.debug("history.state: ", history.state);

        let currState = fsm.getCurrentState();
        fsm.processSubstateEvent(currState, 'back', {});

        m.redraw();
    });
}